import React,{ useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePosition } from '../utils/MapUtils/MapContext/PositionContext';

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import PinListDispla from '../utils/navigationUtils/pinSelectionList';


import { Box, Typography } from '@mui/joy';

import {NavbarPlaceholder} from './Navbar'
import Footer from '../utils/Footer';
import { privacyPolicy } from '../assets/policies/privacyPolicy';

const PrivacyPolicy =()=>{
  
    const [currentMap, setCurrentMap] = useState('WhistlerBlackcomb')
    
    const { setPosition,} = usePosition();

      const [content, setContent] = useState("");

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/PRIVACY_POLICY.md`)
      .then(res => res.text())
      .then(setContent)
      .catch(console.error);
  }, []);

    // navigation calls
    const location = useLocation();
    const navigate = useNavigate()
  
      const handleSetCurrentMap = (map) => {
    setCurrentMap(map)
    setPosition({ latitude: null, longitude: null, zoom: null })
  }
// handles spearhead disclaimer logic


    return (


        <Box className={location.pathname === '/login' ? 'login-background' : ''}>

        <NavbarPlaceholder/>


        <article className="prose max-w-none" style={{ margin: '70px 15px 50px' }}
>
            <ReactMarkdown
                //remarkPlugins={[remarkGfm]}
                //rehypePlugins={[rehypeSanitize]}
            >
                {privacyPolicy}
            </ReactMarkdown>
            </article>
        <Footer/>
        </Box>

    )
}
export {PrivacyPolicy}